import { render } from "./alerts.vue?vue&type=template&id=0aaad1fd&scoped=true"
import script from "./alerts.vue?vue&type=script&lang=js"
export * from "./alerts.vue?vue&type=script&lang=js"

import "./alerts.vue?vue&type=style&index=0&id=0aaad1fd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aaad1fd"]])

export default __exports__